import { enUS, frCA } from 'date-fns/locale';

export const LANGUAGES = {
  english: 'en',
  french: 'fr'
};

export const languageToDateFnsLocale = {
  [LANGUAGES.english]: enUS,
  [LANGUAGES.french]: frCA
};

export const LOCALE_KEY = 'locale';

export const USED_LANGUAGES = Object.values(LANGUAGES);
